import React from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';

// Every 5 minutes. Used by the absence notification create and edit forms.
const TIME_OPTIONS = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 5) {
    const d = dayjs().startOf('day').hour(h).minute(m);
    TIME_OPTIONS.push({ label: d.format('h:mm A'), value: h * 60 + m });
  }
}

// Returns minutes-since-midnight from a dayjs value, or undefined
function toMinutes(val) {
  if (!val || !dayjs.isDayjs(val) || !val.isValid()) return undefined;
  return val.hour() * 60 + val.minute();
}

// Returns a dayjs from minutes-since-midnight
function fromMinutes(minutes) {
  return dayjs().startOf('day').hour(Math.floor(minutes / 60)).minute(minutes % 60);
}

export const DEFAULT_START = fromMinutes(7 * 60);       // 7:00 AM
export const DEFAULT_END   = fromMinutes(15 * 60 + 30); // 3:30 PM

export default function TimeSelect({ value, onChange, placeholder, disabled, style }) {
  return (
    <Select
      value={toMinutes(value)}
      onChange={(minutes) => onChange && onChange(fromMinutes(minutes))}
      options={TIME_OPTIONS}
      placeholder={placeholder || 'Select time...'}
      disabled={disabled}
      style={{ width: '100%', ...style }}
      showSearch
      filterOption={(input, opt) =>
        opt.label.toLowerCase().startsWith(input.toLowerCase())
      }
      listHeight={320}
    />
  );
}
